<template>
  <div class="forgetPassPopup" v-show="ForgetPassShow">
    <div class="background">
        <section class="main clearfix">
          <i class="el-icon-close" @click="colse"></i>
          <div class="contFr fr">
            <el-form style="width=400px" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="1px" class="demo-ruleForm">
              <el-form-item label="" prop="mobile" class="formItems">
                <img class="iconfonts" src="@/assets/images/icon/phone.png" alt="" />
                <el-input class="input clearfix" placeholder="请输入您的手机号" maxlength="11" v-model="ruleForm.mobile"></el-input>
              </el-form-item>

              <el-form-item label="" prop="newPassWord" class="formItems">
                <img class="iconfonts" src="@/assets/images/icon/paswd.png" alt="" />
                <el-input class="input clearfix" placeholder="请输入密码/8-12位数字及字母组合而成" show-password minlength="8" maxlength="12" v-model="ruleForm.newPassWord"></el-input>
              </el-form-item>

              <el-form-item label="" prop="reNewPassWord" class="formItems">
                <img class="iconfonts" src="@/assets/images/icon/paswd.png" alt="" />
                <el-input class="input clearfix" placeholder="请确认密码" show-password maxlength="12" v-model="ruleForm.reNewPassWord"></el-input>
              </el-form-item>

              <el-form-item label="" prop="regCode" class="formItems1" style="margin-bottom:22px;">
                <div class="clearfix">
                  <el-input class="input" placeholder="请输入计算结果" v-model="ruleForm.regCode"></el-input>
                </div>
                <img @click="getImgCodes" class="codeBox imgCode" :src="imgCode" alt="图形验证码" />
              </el-form-item>

              <el-form-item label="" prop="verifyCode" class="formItems1">
                <div class="clearfix">
                  <el-input class="input" placeholder="请输入短信验证码" v-model="ruleForm.verifyCode"></el-input>
                </div>
                <span @click="getCode()" class="codeBox code">{{codeTxt}}</span>
              </el-form-item>

              <el-form-item style="margin-bottom:0;margin-top:62px;">
                <el-button class="register" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                <a class="goLogin" href="javascript:void(0)" @click="goLogin">想起密码，去登录</a>
              </el-form-item>
            </el-form>
          </div>
        </section>
    </div>
    
    <Messages ref="messages" :tips="tipsTxt" />
  </div>
</template>

<script>
import {findPassword,getForgetPassCode} from "@/api/index.js"
import { timestamp,isCellPhone} from "@/utils/proof-technique.js"
import Messages from "@/components/Messages"
import { mapState } from 'vuex';
export default {
  data() {
    // 密码
    let validatePass = (rule, value, callback) => {
      let reg= /^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*.]{8,12}$/;
      if (value === "") {
        callback(new Error("请输入新密码"));
      }else if(!reg.test(value)){
        callback(new Error('密码必须是由8-12位字母+数字组合'))
      } else {
        if (this.ruleForm.reNewPassWord !== "") {
				this.$refs.ruleForm.validateField("reNewPassWord");
        }
        callback();
      }
    };
    // 确认密码
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.ruleForm.newPassWord) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      codeTxt:"获取验证码",
      imgCode:"",
      ruleForm: {
        checked:false,
        mobile:"",
        newPassWord:"",
        reNewPassWord:"",
        regCode:"",
        verifyCode:"",
      },
      rules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            required: true,
            validator: isCellPhone,
            trigger: "blur",
          },
        ],
        newPassWord: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
          },
          {
            validator: validatePass,
            trigger: "blur",
          },
          {
            min: 8,
            max: 12,
            message: "长度在8到12个字符",
            trigger: "blur",
          },
        ],
        reNewPassWord: [
          {
            required: true,
            message: "请再次输入新密码",
            trigger: "blur",
          },
          {
            validator: validatePass2,
            trigger: "blur",
          },
        ],
        verifyCode: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur",
          },
        ],
        regCode: [
          {
            required: true,
            message: "请输入图形验证码",
            trigger: "blur",
          },
        ],
      },
      flag:true,
      timer:"",
      interval:null,
      tipsTxt:""
    }
  },
  components:{
    Messages,
  },
  methods: {
    colse(){
        this.$store.dispatch("ChangeForgetPassShow");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let paswd = this.ruleForm.newPassWord,paswd1 = this.ruleForm.reNewPassWord;
              paswd = this.hrymd5.md5(paswd);
              paswd1 = this.hrymd5.md5(paswd1);
          findPassword({
            mobile:this.ruleForm.mobile,
            newPassWord:paswd,
            reNewPassWord:paswd1,
            verifyCode:this.ruleForm.verifyCode,
            uid:this.timer
          }).then(res=>{
            if(res.data.success){
              this.tipsTxt = "设置成功！";
              this.$refs.messages.show = true;
              setTimeout(() => {
                this.$store.dispatch("ChangeForgetPassShow");
                this.$store.dispatch("ChangeLoginShow");
              }, 800);
            }else{
              if(res.data.msg && res.data.msg!=""){
                this.$message({
                  type: "warning",
                  message: res.data.msg,
                });
              }
            }
          }).catch(err=>{
            console.log(err)
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    beforeDestroy(){
      clearInterval(this.interval);
    },
    goLogin(){
      this.$store.dispatch("ChangeForgetPassShow");
      this.$store.dispatch("ChangeLoginShow");
    },
    getCodeApi(){
      getForgetPassCode({
        mobile:this.ruleForm.mobile,
        forgetCode:this.ruleForm.regCode,
        uid:this.timer
      }).then(res=>{
        if(res.data.success){
          let numB = 60;
          this.flag = false;
          this.$message({
            message: '验证码已发送，请注意查收',
            offset:300,
            type: 'success'
          });
          this.interval = setInterval(() => {
            numB--;
            this.codeTxt = numB + " S 后重新获取";
            if(numB == 0){
              clearInterval(this.interval);
              numB = 0;
              this.codeTxt = "获取验证码";
              this.flag = true;
            }
          }, 1000);
        }else{
          if(res.data.msg && res.data.msg!=""){
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        }
      }).catch(err=>{
        console.log(err)
      });
    },
    getCode(){
      let mobile = this.ruleForm.mobile;
      let regCode = this.ruleForm.regCode;
      if (!mobile) {
        this.$message({
          type: "warning",
          message: "手机号不能为空",
        });
      }else if (!regCode) {
        this.$message({
          type: "warning",
          message: "图形验证码不能为空",
        });
      }else if(this.flag){
        this.getCodeApi();
      }else{
        this.$message({
          message: '倒计时后才能重新获取！',
          offset:300,
          type: 'warning'
        });
      }
    },
    getImgCodes(){
      this.timer = timestamp();
      this.imgCode = process.env.BASE_API + "/code/regCode?uid=" + this.timer;
    }
  },
  computed: {
    ...mapState(['IsLogin','LoginShow','RegisterShow','ForgetPassShow']),
  },
  mounted(){
    this.getImgCodes();
  }
}
</script>

<style lang="less" scoped>
    .forgetPassPopup{
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: 0;
        z-index: 80;
        max-height: 100%;
        overflow: auto;
        .background{
          height: 100%;
          width: 100%;
          position: absolute;
          left:0;
          top:0;
          margin: auto 0;
          padding: 10px 0;
          min-height: 710px;
        }
        .main{
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -349px;
            margin-top:-350px;
            width: 698px;
            height: 700px;
            .el-icon-close{
                position: absolute;
                top: 20px;
                right: 20px;
                font-size: 20px;
                color: #ADADAD;
                cursor: pointer;
            }
            .contFr{
                background: rgba(255,255, 255, 0.85);
                width: 698px;
                height: 700px;
                padding:115px 155px;
                margin: 0 auto;
                border-radius: 10px;
                overflow: hidden;
                .cahngeLogin{
                    font-size: 14px;
                    margin-top: 8px;
                    span{cursor: pointer;}
                    .fl{
                        color: #EB4B12;
                    }
                }
                .goLogin{
                  text-align: center;
                  margin-top: 30px;
                  display: inline-block;
                  width: 100%;
                  font-size: 12px;
                  height: 12px;
                  line-height: 12px;
                }
                .goLogin:hover{
                  color: #EB4B12;
                }
                .loginType{
                    margin-top: 20px;
                    text-align: center;
                    img{
                    margin: 0 31px;
                    cursor: pointer;
                    }
                }
                .orStyle{
                    color: #a72126;
                    display: block;
                    text-align: center;
                    width: 100%;
                    position: relative;
                    font-size: 12px;
                    line-height: 12px;
                }
                .orStyle::after{
                    content: "";
                    display: block;
                    width: 42%;
                    height: 1px;
                    background-color: #a72126;
                    position: absolute;
                    left: 0;
                    top: 5px;
                }
                .orStyle::before{
                    content: "";
                    display: block;
                    width: 42%;
                    height: 1px;
                    background-color: #a72126;
                    position: absolute;
                    right: 0;
                    top: 5px;
                }
                .optins{
                    a,span{
                    font-size: 12px;
                    cursor: pointer;
                    }
                    span{
                    color: #a72126;
                    }
                }
                .formItems1{
                    height: 44px;
                    position: relative;
                    margin-bottom: 0px;
                    background-color: transparent;
                    font-size: 0;
                    /deep/.el-form-item__content{height: 100%;}
                    .clearfix{
                        vertical-align: top;
                        width: 51%;
                        height: 100%;
                        background-color: transparent;
                        padding: 0px 12px 0px 10px;
                        display: inline-block;
                        border-bottom: 1px solid #999;
                        margin-right: 16%;
                        vertical-align: bottom;
                        /deep/.el-input__inner{
                            background-color: transparent;
                        }
                    }
                }
                .formItems{
                    background-color: transparent;
                    padding: 0px 15px;
                    padding-left: 38px;
                    height: 44px;
                    position: relative;
                    border-bottom: 1px solid #999;
                    font-size: 0;
                    /deep/.el-input__inner{background-color: transparent;}
                    .iconfonts{
                        position: absolute;
                        bottom: 6px;
                        left: -38px;
                        height: 23px;
                    }
                }
                .agreement{
                    font-size: 12px;
                    color: #ff0000;
                }
                .agreement:hover{
                    color: rgb(72, 125, 240);
                    cursor: pointer;
                }
                .register{
                    width: 100%;
                    height: 50px;
                    border-radius: 3px;
                    background-color:#EB4B12;
                    border: 0;
                    cursor: pointer;
                }
                .codeBox{
                    width: 32%;
                    height: 43px;
                    cursor: pointer;
                    vertical-align: bottom;
                }
                .code{
                    font-size: 12px;
                    border: 0;
                    width: 32%;
                    vertical-align: bottom;
                    height:43px;
                    background-color: #EB4B12;
                    border-radius: 4px;
                    color: #fff;
                    display: inline-block;
                    text-align: center;
                }
            }
        }
    }
/deep/.el-input__inner{border: 0;}
    /* 设置带边框的checkbox，选中后边框的颜色 */

/deep/.is-checked>.el-checkbox__inner{
  background-color: #EB4B12;
  border-color: #EB4B12;
}
/deep/.is-checked>.el-checkbox__label{
  color: #000;
}
/* 设置checkbox获得焦点后，对勾框的边框颜色 */
/deep/.el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: #EB4B12;
}

</style>


// WEBPACK FOOTER //
// src/components/ForgetPassPopup.vue